import { useState, useEffect, useRef } from 'react';

const slides = [
  {
    src: 'https://public.readdy.ai/ai/img_res/f59533ce6cff75c30077bf87f1d897d8.jpg',
    alt: 'Deux femelles programmeurs travaillant sur nouveau projet',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=programmer%20teamwork%20research%20business%20people%20at%20office%20web%20developer%20bootcamp%20coding%20review%20mentor%20collaboration%20software%20engineer%20group%20employees%20tech%20startup&width=900&height=600&seq=gallery-itec-002&orientation=landscape',
    alt: 'Programmeur, travail d\'équipe et recherche avec les gens d\'affaires au bureau',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=business%20analytics%20artificial%20intelligence%20large%20data%20insights%20data%20mining%20filtering%20sorting%20grouping%20virtual%20computer%20screen%20data%20scientists%20machine%20learning&width=900&height=600&seq=gallery-itec-003&orientation=landscape',
    alt: 'Business analytics with artificial intelligence and large data',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=modern%20engineering%20office%20team%20working%20on%20technical%20blueprints%20infrastructure%20project%20management%20industrial%20design%20professional%20corporate%20workspace&width=900&height=600&seq=gallery-itec-004&orientation=landscape',
    alt: 'Équipe ingénierie bureau technique',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=confident%20male%20programmer%20with%20laptop%20and%20document%20standing%20near%20glass%20wall%20in%20modern%20office%20building%20corporate%20professional%20IT%20consultant&width=900&height=600&seq=gallery-itec-005&orientation=landscape',
    alt: 'Portrait d\'un programmeur masculin confiant avec un ordinateur portable',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=UI%20developer%20team%20brainstorming%20project%20laptop%20smartphone%20digital%20tablet%20creative%20digital%20development%20agency%20virtual%20icons%20modern%20office&width=900&height=600&seq=gallery-itec-006&orientation=landscape',
    alt: 'Vue rapprochée de l\'équipe de développeurs d\'interface utilisateur',
  },
];

export default function GallerySection() {
  const [current, setCurrent] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const goTo = (index: number) => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrent(index);
    setTimeout(() => setIsAnimating(false), 400);
  };

  const prev = () => goTo((current - 1 + slides.length) % slides.length);
  const next = () => goTo((current + 1) % slides.length);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setCurrent((c) => (c + 1) % slides.length);
    }, 4000);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  const visibleSlides = [
    slides[(current) % slides.length],
    slides[(current + 1) % slides.length],
    slides[(current + 2) % slides.length],
  ];

  return (
    <section className="py-12 lg:py-20 bg-brand-dark overflow-hidden">
      <div className="container mx-auto px-6">
        {/* Carousel */}
        <div className="relative">
          <div className="flex gap-4 lg:gap-6 transition-all duration-500">
            {visibleSlides.map((slide, i) => (
              <div
                key={`${current}-${i}`}
                className={`relative overflow-hidden rounded-2xl flex-1 aspect-[3/2] transition-all duration-500 ${
                  i === 0 ? 'opacity-100 scale-100' : 'opacity-80 scale-[0.98]'
                }`}
              >
                <img
                  src={slide.src}
                  alt={slide.alt}
                  className="w-full h-full object-cover object-top"
                  draggable={false}
                />
              </div>
            ))}
          </div>

          {/* Prev / Next buttons */}
          <button
            onClick={prev}
            aria-label="previous"
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 w-10 h-10 bg-brand-dark-card rounded-full shadow-md flex items-center justify-center hover:bg-brand-dark-3 transition-colors cursor-pointer z-10 border border-white/20"
          >
            <i className="ri-arrow-left-s-line text-xl text-gray-200"></i>
          </button>
          <button
            onClick={next}
            aria-label="next"
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 w-10 h-10 bg-brand-dark-card rounded-full shadow-md flex items-center justify-center hover:bg-brand-dark-3 transition-colors cursor-pointer z-10 border border-white/20"
          >
            <i className="ri-arrow-right-s-line text-xl text-gray-200"></i>
          </button>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-4 mt-8">
          {slides.map((_, i) => (
            <button
              key={i}
              onClick={() => goTo(i)}
              className={`w-2.5 h-2.5 rounded-full transition-all cursor-pointer ${
                i === current ? 'bg-brand-teal ring-4 ring-brand-teal/30' : 'bg-white/30 hover:bg-white/50'
              }`}
              aria-label={`Slide ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
